module.exports = __webpack_public_path__ + "img/2.8a01fd23.jpg";